import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import lang from '../../../lib/language';
import { sendResetPassword } from '../../../lib/store/auth';

import Button from '../../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../../shared_components/Button/Button.types';
import { UI_ROUTES } from '../../../util/routes';

import styles from './ChangePassword.module.scss';

type Props = {
    handleModal: () => void;
}

const ChangePasswordModal = ({ handleModal }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleProceed = () => {
    dispatch(sendResetPassword({}));
    navigate(UI_ROUTES.myAccountChangePassword);
    handleModal();
  };

  return (
    <>
      <div className={styles.title}>{lang.mobileChangePasswordModalText()}</div>
      <Button
        variant={ButtonTypesEnum.Tertiary}
        fullWidth
        className={styles.btnCancel}
        onClick={() => handleModal()}
      >
        {lang.commonCancelButton()}
      </Button>
      <Button fullWidth onClick={handleProceed} className={styles.buttonConfirm}>
        {lang.commonOrderSideButtonProceed() }
      </Button>
    </>
  );
};

export default ChangePasswordModal;
